var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49992 1.3335C3.20409 1.3335 1.33325 3.20433 1.33325 5.50016C1.33325 7.796 3.20409 9.66683 5.49992 9.66683C7.79575 9.66683 9.66659 7.796 9.66659 5.50016C9.66659 3.20433 7.79575 1.3335 5.49992 1.3335ZM7.31242 6.98766C7.25409 7.08766 7.14992 7.14183 7.04159 7.14183C6.98742 7.14183 6.93325 7.12933 6.88325 7.096L5.59159 6.32516C5.27075 6.1335 5.03325 5.71266 5.03325 5.34183V3.6335C5.03325 3.46266 5.17492 3.321 5.34575 3.321C5.51659 3.321 5.65825 3.46266 5.65825 3.6335V5.34183C5.65825 5.49183 5.78325 5.71266 5.91242 5.78766L7.20409 6.5585C7.35409 6.646 7.40409 6.83766 7.31242 6.98766Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.f8c39c73229fce669b96c6c2e3c51e34.svg";
export { ForwardRef as ReactComponent };